import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import About from "@/pages/About";
import CaseStudy from "@/pages/CaseStudy";
import WorkAlongsideUs from "@/pages/WorkAlongsideUs";
import CreativeIntelligenceSession from "@/pages/CreativeIntelligenceSession";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/work/:slug" element={<CaseStudy />} />
          <Route path="/work-alongside-us" element={<WorkAlongsideUs />} />
          <Route path="/creative-intelligence-session" element={<CreativeIntelligenceSession />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
